module.exports = __webpack_public_path__ + "img/emptyCart.954a9a85.png";